export enum AppsRedirectTelemetryEvent {
  MsaTenantCodePathStarting = `apps/msa-redirect/msa-tenant-codepath-started`,
  TenantIdLoaded = `apps/msa-redirect/tenantId-loaded`,
  TokenRetrieved = `apps/msa-redirect/token-retrieved`,
  TenantsRetrievedSuccessfully = `apps/msa-redirect/network/tenants-retrieved`,
  TenantsRetrievalFailed = `apps/msa-redirect/network/tenants-failed`,
  NoAADTenants = `apps/msa-redirect/no-aad-tenants`,
  PerformingTenantRedirect = `apps/msa-redirect/redirect-started`
}
